module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider4Post-74a025fd.jpeg";